import {Injectable} from '@angular/core';
import {
    Betriebstaette,
    Kommunikationsmittel,
    StammdatenBetriebstaette,
    StammdatenKommunikation,
    StammdatenTelefonnummer,
    Telefonnummer
} from '@nachdigal';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {AbstractMapper} from '../../abstract.mapper';
import {isNil} from 'lodash';
import {TelefonnummerMapperService} from './telefonnummer-mapper.service';
import {InternetadresseMapperService} from './internetadresse-mapper.service';

@Injectable()
export class BetriebstaettenMapperService extends AbstractMapper<StammdatenBetriebstaette, Betriebstaette> {

  constructor(
    private readonly inlandsadresseMapper: InlandsadresseMapperService,
    private readonly auslandsadresseMapper: AuslandsadresseMapperService,
    private readonly telefonnummerMapper: TelefonnummerMapperService,
    private readonly internetadresseMapper: InternetadresseMapperService
  ) {
    super();
  }

  protected mapInternal(source: StammdatenBetriebstaette): Betriebstaette {

    return {
      bezeichnung: source.bezeichnung,
      inlandsadresse: this.inlandsadresseMapper.map(source.adresse),
      auslandsadresse: this.auslandsadresseMapper.map(source.adresse),
      kommunikationsmittel: this.selectKommunikationsmittel(source.kommunikation)
    };
  }

  private selectKommunikationsmittel(source: StammdatenKommunikation): Kommunikationsmittel {
    if (isNil(source)) {
      return undefined;
    }

    return {
      telefonnummern: this.selectTelefonnummer(source.telefonnummern),
      internet: this.internetadresseMapper.mapArray(source.internetadressen)
    };
  }

  private selectTelefonnummer(telefonnummern: Array<StammdatenTelefonnummer>): Array<Telefonnummer> {

    if (isNil(telefonnummern) || telefonnummern.length < 1) {
      return undefined;
    }

    if (telefonnummern.length <= 2) {
      return [...this.telefonnummerMapper.mapArray(telefonnummern)];
    }

    const standard = telefonnummern.find(value => value.standard);
    if (!isNil(standard)) {
      return [this.telefonnummerMapper.map(standard)];
    }

    return undefined;
  }
}
